module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img5.bccaaa8bfac9c18b3381b3eb4194403e.jpg";